import { createPortal } from 'react-dom';
import React from 'react';
import { once } from 'lodash';

import styles from './styles.css';

const getBody = once(() => {
  return document.getElementsByTagName('body')[0];
});

export const Modal = (children, onBackdropClick) => (
  <div className={styles.root}>
    <div className={styles.backDrop} onClick={onBackdropClick} />
    {children}
  </div>
);

export default class Container extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.hideModal = this.hideModal.bind(this);
  }

  componentDidMount() {
    getBody().appendChild(this.el);
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    getBody().removeChild(this.el);
  }

  hideModal() {
    const { name, props } = this.props;
    return props.hideModal(name);
  }

  render() {
    const { component, props, state } = this.props;
    return createPortal(
      Modal(
        component({ ...props, state, hideModal: this.hideModal }),
        this.hideModal
      ),
      this.el
    );
  }
}
